import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { useTheme } from 'styled-components';
import {
  ContainerTextStyled,
  DescriptionText,
  MainText,
} from './ContainerText.styles';

interface Props {
  text: string;
  description?: string;
  isSelected?: boolean;
  disabled?: boolean;
  margins?: string;
  onClick?: () => void;
  'data-testid'?: string;
  isFixedWidth?: boolean;
  icon?: boolean;
  iconName?: string;
}

export const ContainerText = ({
  text,
  description,
  icon,
  disabled,
  isFixedWidth = true,
  iconName = 'uil uil-ban',
  isSelected,
  ...props
}: Props) => {
  const theme = useTheme();
  return (
    <ContainerTextStyled
      hasDescription={Boolean(description)}
      isFixedWidth={isFixedWidth}
      disabled={disabled}
      isSelected={isSelected}
      {...props}
    >
      {icon && (
        <StyledIcon
          className={iconName}
          color={
            isSelected
              ? theme.atlas.semantic.color.action.primary.onPrimary
              : theme.atlas.semantic.color.type.default
          }
          size="20px"
        />
      )}
      <MainText title={text}>{text}</MainText>
      {description && (
        <DescriptionText title={description}>{description}</DescriptionText>
      )}
    </ContainerTextStyled>
  );
};
